import { z } from 'zod';
import { FINANCIAL_PRODUCT } from '../constants';
import { requiredFieldError, validateE2515HouseholdData } from '../helper';
import { generateSchema, householdSchema } from '../shared';
import { ApplicationStep } from '../types';
import { baseApplicationStep } from './baseApplication';

const customApplicationHouseholdSchema = {
  [FINANCIAL_PRODUCT.ELECTRIFY_2515]: {
    isCashApplication: z.boolean(),
  },
};
const defaultApplicationHouseholdSchema = {};

export const updateApplicationHouseholdSchema = generateSchema<
  typeof customApplicationHouseholdSchema,
  typeof defaultApplicationHouseholdSchema
>({
  customSchemas: customApplicationHouseholdSchema,
  defaultSchema: defaultApplicationHouseholdSchema,
})
  .and(householdSchema)
  .and(
    z
      .object({
        step: z.literal(ApplicationStep.HouseholdDetails),
        hasJointApplicant: z.boolean({ required_error: requiredFieldError() }),
      })
      .and(baseApplicationStep),
  )
  .transform(val => {
    if (val.financialProductId === FINANCIAL_PRODUCT.ELECTRIFY_2515) {
      if ('isCashApplication' in val && val.isCashApplication === true) {
        return {
          ...val,
          applicant: {
            ...val.applicant,
            maritalStatus: undefined,
            dependents: undefined,
            expense: undefined,
            income: {
              householdIncome: val.applicant.income.householdIncome,
              isSkipPrimaryIncome: val.applicant.income.isSkipPrimaryIncome,
            },
          },
        };
      }
    }
    return val;
  })
  .superRefine((val, ctx) => {
    if (val.financialProductId === FINANCIAL_PRODUCT.ELECTRIFY_2515 && 'isCashApplication' in val) {
      validateE2515HouseholdData(val, ctx, val.isCashApplication);
    }
  });
